import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSgFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53798)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 24.9995H0.000488281V9.48222C0.000488281 9.00615 0.386523 8.62012 0.862596 8.62012H49.1384C49.6145 8.62012 50.0005 9.00615 50.0005 9.48222L50.0004 24.9995Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.00146484 25H50.0014V40.5173C50.0014 40.9933 49.6153 41.3794 49.1393 41.3794H0.863573C0.387499 41.3794 0.00146484 40.9933 0.00146484 40.5173V25Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.0882 16.8223C7.0882 13.9876 9.16827 11.6377 11.8844 11.203C12.0318 11.1794 12.0385 10.9766 11.893 10.943C11.2205 10.7884 10.5064 10.7443 9.76475 10.8453C6.83527 11.2443 4.57082 13.7795 4.52941 16.7357C4.48224 20.1113 7.20353 22.8599 10.5631 22.8599C11.0204 22.8599 11.4645 22.8065 11.8918 22.7082C12.0372 22.6748 12.0299 22.4715 11.8826 22.4478C9.16759 22.0134 7.0882 19.6681 7.0882 16.8223Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.929 18.3389L11.6739 19.1041L10.8673 19.1104C10.7629 19.1113 10.7196 19.2445 10.8036 19.3065L11.4525 19.7857L11.2091 20.5547C11.1777 20.6543 11.291 20.7367 11.3759 20.6759L12.0322 20.2069L12.6884 20.6759C12.7734 20.7367 12.8866 20.6542 12.8552 20.5547L12.6118 19.7857L13.2607 19.3065C13.3447 19.2444 13.3014 19.1113 13.197 19.1104L12.3905 19.1041L12.1353 18.3389C12.1022 18.2399 11.962 18.2399 11.929 18.3389Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.9163 18.3389L15.6612 19.1041L14.8546 19.1104C14.7502 19.1113 14.7069 19.2445 14.7909 19.3065L15.4398 19.7857L15.1964 20.5547C15.165 20.6543 15.2783 20.7367 15.3632 20.6759L16.0195 20.2069L16.6757 20.6759C16.7607 20.7367 16.874 20.6542 16.8425 20.5547L16.5991 19.7857L17.248 19.3065C17.3321 19.2444 17.2887 19.1113 17.1843 19.1104L16.3778 19.1041L16.1226 18.3389C16.0895 18.2399 15.9494 18.2399 15.9163 18.3389Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.9407 12.1866L13.6856 12.9518L12.879 12.9581C12.7746 12.9589 12.7313 13.0921 12.8154 13.1541L13.4642 13.6333L13.2208 14.4024C13.1894 14.502 13.3028 14.5843 13.3876 14.5236L14.0439 14.0545L14.7001 14.5236C14.7851 14.5843 14.8984 14.5019 14.8669 14.4024L14.6236 13.6333L15.2724 13.1541C15.3565 13.092 15.3131 12.9589 15.2087 12.9581L14.4022 12.9518L14.147 12.1866C14.1139 12.0875 13.9738 12.0875 13.9407 12.1866Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.7615 14.544L10.5064 15.3092L9.69983 15.3155C9.59544 15.3164 9.55208 15.4496 9.63616 15.5116L10.285 15.9908L10.0416 16.7598C10.0102 16.8594 10.1236 16.9417 10.2084 16.881L10.8647 16.412L11.5209 16.881C11.6059 16.9417 11.7192 16.8593 11.6877 16.7598L11.4444 15.9908L12.0932 15.5116C12.1773 15.4495 12.1339 15.3164 12.0295 15.3155L11.223 15.3092L10.9678 14.544C10.9347 14.445 10.7947 14.445 10.7615 14.544Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.0926 14.544L16.8374 15.3092L16.0309 15.3155C15.9265 15.3164 15.8831 15.4496 15.9672 15.5116L16.616 15.9908L16.3727 16.7598C16.3412 16.8594 16.4546 16.9417 16.5395 16.881L17.1957 16.412L17.852 16.881C17.9369 16.9417 18.0502 16.8593 18.0188 16.7598L17.7754 15.9908L18.4242 15.5116C18.5083 15.4495 18.465 15.3164 18.3606 15.3155L17.554 15.3092L17.2989 14.544C17.2657 14.445 17.1256 14.445 17.0926 14.544Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53798",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSgFlag);
export { ForwardRef as ReactComponent };
